// Global Styles
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';

import registerServiceWorker from './services/service-worker';
import init from './services/init';
import Routes from './routes';

init();

const App = () => <Routes />;

ReactDOM.render(
  <App />,
  document.getElementById('root'),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js